// Landing hero photo (L1, T21): responsive AVIF / WebP / JPEG derivatives of one master photo,
// made without crop. To swap the photo, regenerate these nine files under the same names
// (src/assets/hero/hero-{800,1200,1600}.{avif,webp,jpg}); no code change is needed.
import avif800 from '../../../../assets/hero/hero-800.avif';
import avif1200 from '../../../../assets/hero/hero-1200.avif';
import avif1600 from '../../../../assets/hero/hero-1600.avif';
import webp800 from '../../../../assets/hero/hero-800.webp';
import webp1200 from '../../../../assets/hero/hero-1200.webp';
import webp1600 from '../../../../assets/hero/hero-1600.webp';
import jpg800 from '../../../../assets/hero/hero-800.jpg';
import jpg1200 from '../../../../assets/hero/hero-1200.jpg';
import jpg1600 from '../../../../assets/hero/hero-1600.jpg';

const srcSet = (...files) => files.map(([src, w]) => `${src} ${w}w`).join(', ');

// Rendered width of .primaryHeroImage, measured per band (max 600px: at 2x that is exactly the
// 1200w file, so Retina desktops stay on hero-1200).
const SIZES = [
  '(max-width: 360px) calc(100vw - 64px)',
  '(max-width: 611px) calc(100vw - 72px)',
  '(max-width: 899px) 540px',
  '(max-width: 1439px) 37vw',
  '(max-width: 1535px) 33vw',
  '(max-width: 1679px) 540px',
  '600px',
].join(', ');

export const heroImage = {
  avif: srcSet([avif800, 800], [avif1200, 1200], [avif1600, 1600]),
  webp: srcSet([webp800, 800], [webp1200, 1200], [webp1600, 1600]),
  jpg: srcSet([jpg800, 800], [jpg1200, 1200], [jpg1600, 1600]),
  src: jpg1200,
  sizes: SIZES,
  // Intrinsic size of the largest file: the aspect ratio for layout, not the rendered size.
  width: 1600,
  height: 1067,
};
